// extracted by mini-css-extract-plugin
export default {"button":"CartButton_button__TLbzJ","cartIcon":"CartButton_cartIcon__q0tbp","price":"CartButton_price__tk1Yb","count":"CartButton_count__4BPDR"};